export interface ClipboardState {
  clipboardValues: string[];
}

export const state: ClipboardState = {
  clipboardValues: [],
};
